import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useHistory} from "react-router-dom";
import {Box, Grid, Button} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import BannerMobile from "../../assets/images/why_carwiser_banner_mobile.png"
import BannerDesktop from "../../assets/images/why_carwiser_banner_desktop.png"

const useStyles = makeStyles((theme) => ({
    iframe: {
        width: '100%',
        border: 'none',
        overflow: 'auto'
    },
    iframeMobile: {
        minHeight: '500px'
    },
    iframeDesktop: {
        minHeight: '400px'
    },
    banner: {
        width: '100%',
        margin: 'auto'
    }
}));

const Promo = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const desktop = useMediaQuery('(min-width:800px)');

    return (
        <React.Fragment>
            <h3 className={classes.title} style={{margin:'16px 0 10px 0'}}>Why Carwiser?</h3>
            <Box style={{position:'relative', width:'100%', height:'129px', overflow:'hidden'}} >
                <img src={desktop ? BannerDesktop : BannerMobile} className={classes.banner} />
            </Box>
            <iframe className={[classes.iframe,(desktop ? classes.iframeDesktop : classes.iframeMobile)].join(' ')} src="https://s3.amazonaws.com/www.carwiser.com/promo-page.html"></iframe>
            <Grid container direction="row"
                justify="flex-end"
                alignItems="center"
            >
                <Box className={classes.bottomControlBox} style={{marginBottom:'50px'}}>
                    <Button className={classes.button} variant="contained" color="primary" component="span" size="medium"
                            onClick={() => {
                                history.replace("/dashboard")
                            }}>Back To Dashboard</Button>
                </Box>
            </Grid>
        </React.Fragment>
    );
}

export default Promo;